import { Link } from "react-router-dom";
import { Minus, Plus, Trash2 } from "lucide-react";
import { imgUrl, eur } from "../../lib/api";
import { useCart } from "../../context/CartContext";
import { useLang } from "../../context/LangContext";
import { conditionLabel, contentsLabel } from "../../lib/editions";
import { LangBadge, AvailabilityLine } from "./Flag";

export const EditionFacts = ({ i, compact = false }) => {
  const { t, lang, tr } = useLang();
  const rows = [[tr("Set", "Set"), i.set_name], [tr("Produkttyp", "Product type"), t("cat")[i.category]], [tr("Inhalt", "Contents"), contentsLabel(i, lang)],
    [tr("Zustand", "Condition"), conditionLabel(i, lang)], ...(compact ? [] : [["SKU", i.sku]])].filter(([, v]) => v);
  return (
    <dl className="text-xs text-[#707783] space-y-0.5">
      {rows.map(([k, v]) => <div key={k} className="flex gap-1.5"><dt>{k}:</dt><dd className="text-[#120E1F] font-mono-ish">{v}</dd></div>)}
    </dl>
  );
};

export const CartLine = ({ i, notice, compact = false }) => {
  const { setQty, remove } = useCart();
  const { pname, tr } = useLang();
  const max = Math.min(i.stock ?? 99, i.max_per_order || 5);
  return (
    <div className="flex gap-4 bg-white rounded-2xl p-4 border border-[#120E1F]/5" data-testid={`cart-item-${i.slug}`}>
      <Link to={`/product/${i.slug}`} className="shrink-0"><img src={imgUrl(i.image)} alt="" className={`${compact ? "h-24 w-20" : "h-32 w-28"} object-cover rounded-xl bg-[#F7F5FB]`} /></Link>
      <div className="flex-1 min-w-0 space-y-2">
        <div className="flex items-start gap-2">
          <Link to={`/product/${i.slug}`} className="flex-1 text-sm font-semibold text-[#120E1F] leading-snug hover:text-[#6E3FB8]" data-testid={`cart-title-${i.slug}`}>{pname(i)}</Link>
          <button data-testid={`cart-remove-${i.slug}`} onClick={() => remove(i.id)} aria-label="remove" className="p-1 text-[#707783] hover:text-red-600 transition-colors"><Trash2 className="h-4 w-4" /></button>
        </div>
        <div className="flex flex-wrap gap-2 items-center"><LangBadge code={i.language} testid={`cart-lang-${i.slug}`} /><AvailabilityLine p={i} testid={`cart-avail-${i.slug}`} /></div>
        <EditionFacts i={i} compact={compact} />
        {notice && <p className="text-xs rounded-lg bg-[#F2C230]/15 text-[#8A5A00] px-2 py-1" data-testid={`cart-notice-${i.slug}`}>{notice}</p>}
        <div className="flex flex-wrap items-center justify-between gap-3 pt-1">
          <div className="flex items-center border border-[#120E1F]/10 rounded-full">
            <button data-testid={`cart-dec-${i.slug}`} disabled={i.quantity <= 1} onClick={() => setQty(i.id, i.quantity - 1)} className="p-2 disabled:opacity-30"><Minus className="h-3 w-3" /></button>
            <span className="w-7 text-center text-sm font-mono" data-testid={`cart-qty-${i.slug}`}>{i.quantity}</span>
            <button data-testid={`cart-inc-${i.slug}`} disabled={i.quantity >= max} onClick={() => setQty(i.id, i.quantity + 1)} className="p-2 disabled:opacity-30"><Plus className="h-3 w-3" /></button>
          </div>
          <div className="text-right">
            <p className="text-[10px] text-[#707783]">{eur(i.price)} {tr("/ Stück", "each")}</p>
            <p className="font-mono font-semibold text-[#120E1F]" data-testid={`cart-line-total-${i.slug}`}>{eur(i.price * i.quantity)}</p>
          </div>
        </div>
      </div>
    </div>
  );
};
